angular.module('qkr').directive('vizBarchart', ($parse, $window) => ({
        restrict: 'EA',
        template: '<svg width=\'850\' height=\'200\'></svg>',
        link(scope, elem, attrs) {
            const exp = $parse(attrs.chartData);

            let dataToPlot = exp(scope);
            const padding = 20;
            const pathClass = 'path';
            let xScale, yScale, xAxisGen, yAxisGen, lineFun;

            const d3 = $window.d3;
            const rawSvg = elem.find('svg');
            const svg = d3.select(rawSvg[0]);

            scope.$watchCollection(exp, (newVal, oldVal) => {
                dataToPlot = newVal;
                drawLineChart();
            });

            function setChartParameters() {
                xScale = d3.scale.linear()
                    .domain([dataToPlot[0].x, dataToPlot[dataToPlot.length - 1].x])
                    .range([padding + 5, rawSvg.attr('width') - padding]);

                yScale = d3.scale.linear()
                    .domain([0, d3.max(dataToPlot, (d) => d.y)])
                    .range([rawSvg.attr('height') - padding, 0]);

                xAxisGen = d3.svg.axis()
                    .scale(xScale)
                    .orient('bottom')
                    .ticks(dataToPlot.length - 1);

                yAxisGen = d3.svg.axis()
                    // .scale(yScale)
                    .orient('left')
                    .ticks(5);

                lineFun = d3.svg.line()
                    .x((d) => xScale(d.x))
                    .y((d) => yScale(d.y))
                    .interpolate('basis');
            }

            function drawLineChart() {
                setChartParameters();

                svg.append('svg:g')
                    .attr('class', 'x axis')
                    .attr('transform', 'translate(0,180)')
                    .call(xAxisGen);

                svg.append('svg:g')
                    .attr('class', 'y axis')
                    .attr('transform', 'translate(20,0)')
                    .call(yAxisGen);

                svg.append('svg:path')
                    .attr({
                        'd': lineFun(dataToPlot),
                        'stroke': 'blue',
                        'stroke-width': 2,
                        'fill': 'red',
                        'class': pathClass
                    });
            }

            function hasChartData() {
                return dataToPlot != null && dataToPlot.length > 0;
            }
        }

    }));



// WEBPACK FOOTER //
// ./src/directives/data-viz/bar-chart.js